import { BubbleChart } from '@mantine/charts';

import { makeFieldFormatter } from '#core/lib/formatters/number-decimals.ts';

import type { ChartRendererProps } from '../types.ts';

/**
 * Renders bubble chart.
 */
export function BubbleChartRenderer({ config, width, height }: ChartRendererProps) {
  const firstRow = config.data.at(0) ?? {};
  const otherNumericField = Object.keys(firstRow).find(
    (k) => k !== config.xAxis && k !== config.yAxis && typeof firstRow[k] === 'number',
  );
  const zKey = otherNumericField ?? config.yAxis;

  const zValues = config.data.map((row) => {
    const val = row[zKey];
    return typeof val === 'number' ? val : 0;
  });
  const range: [number, number] = [Math.min(...zValues, 0), Math.max(...zValues, 100)];

  const xFormatter = makeFieldFormatter(config.data, config.xAxis);
  const yFormatter = makeFieldFormatter(config.data, config.yAxis);
  const zFormatter = makeFieldFormatter(config.data, zKey);

  return (
    <BubbleChart
      data={config.data}
      dataKey={{ x: config.xAxis, y: config.yAxis, z: zKey }}
      h={height}
      label={config.title}
      range={range}
      valueFormatter={zFormatter}
      w={width}
      withTooltip
      xAxisProps={{ tickFormatter: xFormatter }}
      yAxisProps={{ tickFormatter: yFormatter }}
    />
  );
}
